// Camada única para eventos do funil.
// A implementação global registra a métrica interna anônima sempre e só envia
// à Meta quando existe consentimento explícito para publicidade.
//
// Instrumentação ajustada em 09/09/2026 durante a campanha ativa:
// - CTAs gerais da LP não são mais classificados como CTA do caso real.
// - Dados financeiros da simulação nunca seguem para a camada Meta.
const GENERAL_REGISTRATION_CTA_SOURCES = new Set([
  'plataforma_final_header',
  'plataforma_final_hero',
  'plataforma_final_offer',
  'plataforma_final_cta',
]);

const META_SAFE_PROPERTIES = new Set([
  'source',
  'case_ref',
  'content_name',
  'content_category',
  'leilao_id',
]);

function sanitizeProperties(name, properties = {}) {
  if (name !== 'simulation_started' && name !== 'simulation_completed') {
    return properties;
  }

  return Object.fromEntries(
    Object.entries(properties).filter(([key]) => META_SAFE_PROPERTIES.has(key))
  );
}

export function trackFunnel(name, properties = {}) {
  if (typeof window === 'undefined') return null;

  // A LP usava historicamente case_cta_clicked também nos CTAs gerais de
  // cadastro. Interrompemos essa contaminação sem alterar a experiência, a rota
  // /register ou o evento de conversão CompleteRegistration da campanha.
  if (name === 'case_cta_clicked' && GENERAL_REGISTRATION_CTA_SOURCES.has(properties?.source)) {
    return null;
  }

  return window.leilancerAnalytics?.track?.(name, sanitizeProperties(name, properties)) || null;
}

export function trackMetaOnly(name, properties = {}) {
  if (typeof window === 'undefined') return null;
  return window.leilancerMeta?.track?.(name, sanitizeProperties(name, properties)) || null;
}
